// console.log("custom.js file loaded.");

document.addEventListener("theme:variant:change", (event) => {
 //console.log("Variant changed! Here’s the event detail:", event.detail.variant.title);
  let variant = event.detail.variant.title.split(" / ").pop();
  const elements = document.querySelectorAll(".ef__product-option-root");

  elements.forEach((el) => {
    if (variant === "custom") {
      el.setAttribute("style", "display: block !important;");
    } else {
      el.setAttribute("style", "display: none !important;");
      // set value blank
      let customInputElement = document.querySelector(".ef__product-option-input").value;
      if (customInputElement) {
        document.querySelector(".ef__product-option-input").value = "";
      }
    }
  });
});
